import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';

/*  Explanation: Inject this service to register icons so that you and svg as a maticon
 *  How to register: 
 *    constructor(iconRegistryService: IconRegistryService) {
 *      iconRegistryService.registerIcon('user', './assets/icons/icons8-customer.svg');
 *    }
 *
 *  How to use in html: <mat-icon svgIcon="user"></mat-icon>
*/

@Injectable({
  providedIn: 'root'
})
export class IconRegistryService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) { }

  public registerIcon(iconName: string, iconPath: string): void {
    if (iconName === null || iconName === undefined || iconName.trim() === "") return;
    if (iconPath === null || iconPath === undefined || iconPath.trim() === "") return;

    this.matIconRegistry.addSvgIcon(
      iconName,
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconPath)
    );
  }
}
